// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const BannerContract = contract({
  name: "Banner",
  description: "A full-width horizontal strip surfacing system-level state, announcements, or first-run guidance — \"you're previewing a draft\", \"investigating incident\", \"new feature available\", \"send your design to Figma\". Distinct from Callout (inline boxed message in the layout flow), Toast (transient floating notification), Dialog (modal interrupt). Banner is what lives at the TOP of an AppShellHeader, page, or panel.",
  import: "@gradeui/ui",
  aliases: ["banner","notification banner","system banner","header banner","announcement bar","top bar","status bar","promo banner","incident banner","draft banner","first run banner","glass banner","sticky banner"],
  composesWith: ["AppShellHeader (most common host — banner sits ABOVE the header content)","Button (in the action slot)","Link (inside the content)","Lucide icons (in the icon slot)"],
  styleDefaults: {"Banner":"relative flex items-center gap-3 px-4 py-2.5 text-sm leading-relaxed border-b bg-muted text-foreground border-border [&>svg]:text-muted-foreground justify-between"},
  variantDefaults: {"variant":"default","align":"between"},
  props: {
  "variant": {
      schema: z.enum(["default", "info", "success", "warning", "destructive", "announcement"]).optional(),
      design: "knob",
      description: "intent + tonal direction. `default` is a calm muted strip; `announcement` is a low-alpha brand tint for \"new feature\" messaging; status variants pick up the soft+deep token pairs.",
  },
  "surface": {
      schema: z.enum(["solid", "translucent", "glass", "glass-strong"]).optional(),
      design: "knob",
      description: "material applied over the variant tint. `glass` for banners that sit over imagery / generative backdrops.",
  },
  "align": {
      schema: z.enum(["start", "center", "between"]).optional(),
      design: "knob",
      description: "justify behaviour of the inner flex row. Defaults to `between` so the action / dismiss button right-align.",
  },
  "sticky": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "stick to the top of the scroll container.",
  },
  "dismissible": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "render the trailing X close button. Pair with `onDismiss` to react.",
  },
  "onDismiss": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "icon": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "leading icon slot. NOT inferred from variant; pass what fits the message.",
  },
  "action": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "trailing slot before dismiss. Usually a `<Button size=\"sm\">` or `<a>`.",
  },
  "role": {
      schema: z.string().optional(),
      design: "plumbing",
      description: "overrides the automatic role mapping (warning/destructive → alert, others → status).",
  },
  },
});
